import { render } from "./DashboardAutocomplete.vue?vue&type=template&id=492b8b64&scoped=true"
import script from "./DashboardAutocomplete.vue?vue&type=script&lang=ts"
export * from "./DashboardAutocomplete.vue?vue&type=script&lang=ts"

import "./DashboardAutocomplete.vue?vue&type=style&index=0&id=492b8b64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-492b8b64"

export default script